import React from 'react';
import { DateTimeRangePickerProps, DateTimeRangePicker } from '../../components';
import { fullstorySelectors } from '@fullstory/redux';
import { useSelector } from 'react-redux';

export const DateTimeRangePickerContainer = (
  props: Omit<DateTimeRangePickerProps, 'retentionTimestamp'> & { showRetention?: boolean },
) => {
  const retentionTimestamp = useSelector(fullstorySelectors.getRetentionTimestamp);
  return (
    <DateTimeRangePicker
      data-component="DateTimeRangePickerContainer"
      {...props}
      retentionTimestamp={props.showRetention ? retentionTimestamp : undefined}
    />
  );
};
